const common = {
  /**
   * 时间转为秒
   * @param time 时间(00:00:00)
   * @returns {string} 时间戳（单位：秒）
   */
  time_to_sec(time) {
    var s = "";

    var hour = time.split(":")[0] ? time.split(":")[0] : 0;
    var min = time.split(":")[1] ? time.split(":")[1] : 0;
    var sec = time.split(":")[2] ? time.split(":")[2] : 0;

    s = Number(hour * 3600) + Number(min * 60) + Number(sec);

    return s;
  },


  // 获取当前时区
  getTimeZone() {
    var nowTime = new Date();
    var offset = nowTime.getTimezoneOffset() / 60;
    return -offset;
  },

  //把秒数转换为时分秒的不同格式
  ForamtTime(times, format = 1, is_second = false) {
    var time;
    if (is_second) {
      time = times
    } else {
      time = this.time_to_sec(times);
    }

    // 转换为式分秒
    let h = parseInt((time / 60 / 60) % 24);
    if (format == 3) {
      h = h < 10 ? '0' + h : h
    }

    let m = parseInt((time / 60) % 60);

    if (format == 3) {
      m = m < 10 ? "0" + m : m;
    }
    let s = parseInt(time % 60);
    // s = s < 10 ? "0" + s : s;
    // 作为返回值返回
    if (format == 1) {
      return h + "h" + m + "m";
    } else if (format == 2) {
      return h + "H" + m + "m";
    } else if (format == 3) {
      return h + ":" + m;
    }
  },

  //把时间戳转换为日期格式
  FormTimeStamp(time, format = 1) {
    const date = new Date(time);
    const Y = date.getFullYear();
    const M =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    const D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

    const H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); // 小时
    const I =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); // 分钟
    const S =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); // 秒

    if (format == 1) {
      return `${M}-${D} ${H}:${I}`;
    } else if (format == 2) {
      return `${H}:${I}`;
    } else if (format == 3) {
      return `${Y}-${M}-${D} ${H}:${I}:${S}`;
    }else if(format==4){
      return `${M}-${D}`;
    }
  },

  //获取与目标数值最为接近的值
  findCloseNum(num, type = 0, array = null) {
    var arr = null
    if (array != null) {
      arr = array
    } else {
      arr = [
        "050",
        "060",
        "070",
        "080",
        "090",
        100,
        110,
        120,
        130,
        140,
        150,
        160,
        170,
        180,
        190,
        200,
        210,
        220,
        230,
        240,
        250,
        260,
        270,
        280,
        290,
        300,
        310,
        320,
        330,
        340,
        350,
        360,
        370,
        380,
        390,
        400,
        410,
        420,
        430,
        440,
        450
      ];
    }

    var index = 0;
    var d_value = Number.MAX_VALUE;
    for (var i = 0; i < arr.length; i++) {
      var new_d_value = Math.abs(arr[i] - num);
      if (new_d_value <= d_value) {
        if (new_d_value === d_value && arr[i] < arr[index]) {
          continue;
        }

        if (type > 0) {
          index = i + 1;
        } else {
          index = i;
        }

        d_value = new_d_value;
      }
    }
    return arr[index];
  },

  //获取日期集合
  getDateList(time=null,type=1) {
    // 创建一个空数组来存储日期
    var dateArray = [];

    // 获取当前日期
    if(!time){
      var currentDate = new Date();
    }else{
      var currentDate = time;
    }
    

    // 从当前日期开始向前循环7次，每次减去一天
    for (var i = 0; i < 7; i++) {
      // 减去一天
      currentDate.setDate(currentDate.getDate() - 1);
      // 将当前日期添加到数组中
      var date=currentDate.toISOString().slice(0, 10)
      if(type==1){
        dateArray.push(date);
      }else if(type==2){
        var dates= new Date(date).getTime()
        dateArray.push(this.FormTimeStamp(dates,4));
      }

    }

    // 打印日期集合
    return dateArray.reverse()

  }
};
export default common;



// WEBPACK FOOTER //
// ./src/util/common.js